import usePersonPositionCertificationNoteDropdown from './UsePersonPositionCertificationNoteDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const PersonPositionCertificationNoteDropdown = ({ label, name, value, error, message, onChange, orgLevelId, officialPositionTypeId }) => {
  const { personPositionCertificationNoteState } = usePersonPositionCertificationNoteDropdown(orgLevelId, officialPositionTypeId);

  return personPositionCertificationNoteState.message
    ? <span className={global.LoadingMsg}>{personPositionCertificationNoteState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={personPositionCertificationNoteState.options}
        name={name}
        value={value}
        onChange={onChange}
        areValuesIntegers={true}
        isLoading={personPositionCertificationNoteState.isArrayLoading} />
    );
};

export default PersonPositionCertificationNoteDropdown;